// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__s8xDZ","alert":"SettungsInbox_alert__2WG4W"};